"use client";

import { TbLassoPolygon } from "react-icons/tb";

import { cn } from "@/lib/utils";
import { Nullable } from "@/types/common";
import { TransformationType } from "@/types/thread";
import { useGenContext } from "@/context/GenContext";
import Image from "@/components/common/Image";

interface SourceImagesProps {
  rawImageUrl: Nullable<string>;
  isSubscribed: boolean;
  inspirationImages?: string[];
  modelUsed?: TransformationType;
}

const SourceImages: React.FC<SourceImagesProps> = ({
  rawImageUrl,
  isSubscribed,
  inspirationImages = [],
  modelUsed,
}) => {
  const { addImage } = useGenContext();

  const displayedInspirationImages = [...inspirationImages];
  if (rawImageUrl) {
    displayedInspirationImages.unshift(rawImageUrl);
  }

  const handleImageClick = (imageUrl: string) => {
    if (!isSubscribed) return;
    addImage(imageUrl);
  };

  if (!rawImageUrl && inspirationImages.length === 0) return null;

  return (
    <div className="tw:flex tw:w-full tw:max-w-[calc(100vw-32px)] tw:mt-2 tw:lg:max-w-[605px]">
      <div className="tw:flex tw:gap-1 tw:overflow-x-auto tw:no-scrollbars">
        {displayedInspirationImages.map((image, i) => (
          <div
            key={`inspiration-preview-${i + 1}`}
            className={cn(
              "tw:inline-block tw:flex-none tw:relative",
              isSubscribed && "tw:cursor-pointer"
            )}
            onClick={() => handleImageClick(image)}
          >
            <Image
              width={84}
              height={84}
              src={image}
              alt={`Inspiration Image ${i + 1}`}
              className="tw:relative tw:object-cover tw:overflow-hidden tw:rounded-[5px] tw:bg-[#ececec]"
            />
            {modelUsed === TransformationType.InPaint && (
              <TbLassoPolygon className="tw:absolute tw:bottom-1 tw:right-0 tw:w-[30px] tw:h-[30px] tw:p-1 tw:text-2xl tw:text-white tw:bg-black/50 tw:filter tw:drop-shadow-[0_0_1px_#1E222A] tw:rounded-full" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SourceImages;
